export const trackEvent = (event, data = {}) => {
    if (typeof fbq === 'undefined') {
        return;
    }

    // https://developers.facebook.com/docs/facebook-pixel/reference#standard-events

    const standardEvents = [
        'AddPaymentInfo',
        'AddToCart',
        'AddToWishlist',
        'CompleteRegistration',
        'Contact',
        'CustomizeProduct',
        'Donate',
        'FindLocation',
        'InitiateCheckout',
        'Lead',
        'PageView',
        'Purchase',
        'Schedule',
        'Search',
        'StartTrial',
        'SubmitApplication',
        'Subscribe',
        'ViewContent',
    ];

    fbq(
        standardEvents.indexOf(event) > -1 ? 'track' : 'trackCustom',
        event,
        data,
    );
};
